<div class="profile-container">
  <div class="">
    <div class="profile-content">
      <div class="personal-details">

        <div class="header-block">
          <div class="header-title">
            <app-breadcrumb></app-breadcrumb>
          </div>
          <div class="add-block">
            <span class="excel" *ngIf="objectData && objectData.length != 0 && !isExcelDownload"
              (click)="downloadExcel()">
              <img src="assets/img/Microsoft_Excel-Logo.wine.svg" alt="">
            </span>
            <div class="spinner-container" *ngIf="isExcelDownload"
              style="display: flex; align-items: center; justify-content: center; width: 35px; height: 35px; margin-right: 15px;">
              <div class="spinner" style="width: 20px; height: 20px; border-width: 2px;"></div>
            </div>

            <select name="categorySelect" id="categorySelect" [(ngModel)]="selectedCategoryObj"
              (change)="onCategoryChange()">
              <option [ngValue]="null" disabled> -- select category -- </option>
              <option *ngFor="let cat of reportsCategory" [ngValue]="cat">{{ cat.category }}</option>
            </select>

            <select name="reportSelect" id="reportSelect" *ngIf="selectedCategoryObj"
              (change)="reportChange(assetReportIdName)" [(ngModel)]="assetReportIdName">
              <option disabled value=""> -- select report -- </option>
              <option *ngFor="let item of selectedCategoryObj.reports" [value]="item.value">{{ item.label }}</option>
            </select>

            <select name="locationSelect" id="locationSelect" *ngIf="isLocation" [(ngModel)]="locationId">
              <option disabled value=""> -- select location -- </option>
              <option *ngFor="let loc of locationList" [value]="loc.locationId">{{ loc.city }} - {{ loc.postalCode }}
              </option>
            </select>



            <input type="date" *ngIf="isFromDate" [(ngModel)]="fromDate">
            <span *ngIf="isToDate && isFromDate">To</span>
            <input type="date" *ngIf="isToDate" [(ngModel)]="toDate">
            <button (click)="getReportSelection(0,10)">Submit</button>
            <div class="filter-icon">
              <i class="bi bi-arrow-clockwise" (click)="refreshAll()" title="Refresh"></i>
            </div>
          </div>
        </div>

        <div *ngIf="isLoading" class="d-flex justify-content-center mt-4" style="text-align: center; margin-top: 20px;">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <div *ngIf="!isLoading && isResponse && (!objectData || objectData.length === 0)" class="text-center mt-4"
          style="text-align: center; margin-top: 20px;">
          <h4>No data found</h4>
        </div>

        <div *ngIf="!isLoading && objectData && objectData.length != 0">
          <table class="table table-striped">
            <thead>
              <tr>
                <th *ngFor="let key of tableKeys | slice:0:7">{{ key }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let obj of objectData">
                <td *ngFor="let key of tableKeys | slice:0:7">
                  <!-- {{ obj[key] }} -->
                  {{ key.toLowerCase().includes('date') ? (obj[key] | date) : obj[key] }}

                </td>
              </tr>
            </tbody>
          </table>

          <!-- <div *ngIf="!isLoading && objectData && objectData.length != 0" >
            <div class="data-view" *ngFor="let obj of objectData | paginate : {
                itemsPerPage: tableSize,
                currentPage: pageNumber,
                totalItems: totalRecords
                }  ;let i = index">

                <p *ngFor="let key of tableKeys">{{ obj[key] || " -- "}}</p>
            </div>
          </div> -->

          <div class="loader" *ngIf="isLoading">
            <div class="spinner"></div>
          </div>



          <div class="paginator">
            <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
              [totalRecords]="totalRecords" [showFirstLastIcon]="false" [showCurrentPageReport]="true"
              currentPageReportTemplate="{first} - {last} of {totalRecords}">
            </p-paginator>
          </div>
        </div>
        <!-- <div class="loader"  *ngIf="isResponse && objectData.length == 0">
          <div class="no-data">
            <img src="assets/no-data-6.png" alt="">
            <p>no data found</p>
          </div>
        </div> -->

      </div>
    </div>
  </div>
</div>